<!-- 资讯正文页 纯富文本组件 -->
<template>
  <div
    v-if="text && text.length"
    class="widget-rich-text-wrapper"
    :class="styl"
    v-html="text"
  ></div>
</template>

<script>
export default {
  props: {
    // 纯富文本内容
    data: {
      type: String,
      default: ''
    },
    // light dark
    styl: {
      type: String,
      default: 'light'
    }
  },
  data() {
    return {
      // 暂时临时性删除style样式
      // text:this.data.replace(/style=['"](.+?)['"]/gi, '').replace(/<p>(&nbsp;)*(<br\/>)*<\/p>/gi, '')

      // 删除样式 删除空行 保留颜色
      // text:(() => {

      // 	//
      // 	var richtext = this.data
      // 	.replace(/style=['"](.+?)( color:.+?;)(.+?)['"]/gi, 'style="$2"')
      // 	.replace(/<p>(&nbsp;)*(<br\/>)*<\/p>/gi, '')
      // 	.replace(/<p><strong style=['"](.+?)['"]><strong><span style=['"](.+?)['"]><strong style=['"](.+?)['"]><br\/><\/strong><\/span><br\/><\/p>/gi, '');

      // 	//对于没有color的style，还需要单独清除一下
      // 	if(!/ color/.test(richtext)) {
      // 		richtext = richtext.replace(/style=['"](.+?)['"]/gi, '')
      // 	}

      // 	return richtext;
      // })()
      text: this.data
        .replace(/&#39;/gi, '')
        // .replace(/style=['"](.+?)['"]/gi, 'style="begin; $1;color:#4D4D4D; end"')
        // .replace(/style=['"](.+?)(color:.+?;)(.+?)['"]/gi, 'style="$2"')
        // .replace(/color:#4D4D4D;/gi, '')
        // .replace(/255, 255, 255/gi, '77, 77, 77')
        // .replace(/#ffffff/gi, '#4D4D4D')
        // .replace(/>&nbsp;</gi, '><')
        // .replace(/><br\/></gi, '><')
        .replace(/class=['"](.+?)['"]/gi, '')
    }
  }
}
</script>

<style lang="scss">
/*正文*/
/*图片最大不能超过100%*/ /*这个地方对于图片的设置 需要提取到外层 scope之外*/
.widget-rich-text-wrapper {
  font-size: 16px;
  line-height: 1.7em;
  strong,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  b {
    font-weight: bold;
    span,
    em,
    i {
      font-weight: bold;
    }
  }
  &.dark {
    color: #d5dce6;
  }
  p {
    margin-bottom: 1em;
    word-break: break-word;
  }
  img {
    display: block;
    max-width: 100%;
    margin: 10px auto;
  }
  a,
  a:link,
  a:visited,
  a:hover,
  a:active {
    color: #1da1f2;
    text-decoration: none;
  }
}
</style>
